import { useRecoilValue } from "recoil";
import { Navigate, Outlet } from "react-router-dom";
import { authState } from "../../Recoil/RecoilState";

// Route guard: only superadmins may open the workspace management pages.
const RequireSuperadmin = () => {
  const authRecoil = useRecoilValue(authState);
  if (authRecoil?.role !== "superadmin") return <Navigate to="/" />;
  return <Outlet />;
};

export default RequireSuperadmin;
